import {
  takeLeading, put, select, call,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { authActions } from '@/redux/modules/auth';
import homeActions from './home.actions';
import { HomeActionTypes } from './home.types';
import { config } from '@/config';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import { CHARLIE_FORCE_UPDATE_JWT_IN_REDUCERS } from '@/config/GrowthBook/constants';

const { WHMCS_URL } = config;

export const getHomeContent = function* getHomeContent() {
  const { toggles } = yield select(state => state.common);
  const forceUpdateJwtInReducers = toggles[CHARLIE_FORCE_UPDATE_JWT_IN_REDUCERS];
  if (forceUpdateJwtInReducers === 'true') {
    yield put(authActions.tokens.jwt.update());
  }

  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${WHMCS_URL}/api/v3/pages/home`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
  };

  yield put(homeActions.loading(true));

  try {
    const response = yield call(api.whmcs.get, request);
    yield put(homeActions.getHomeContent.success());

    yield put(homeActions.getHomeContent.set(response.data && response.data.modules));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas homeContent - method getHomeContent', error);
    yield put(homeActions.getHomeContent.failure());
  }

  yield put(homeActions.loading(false));
};

function* sagas() {
  yield takeLeading(HomeActionTypes.HOME_GET_REQUEST, getHomeContent);
}

export default sagas;
